import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/HomePopup.css";

export default function HomePopup({ image, link, buttonText = "Tap to Register", onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  const isExternal = /^https?:\/\//.test(link);
  const inner = (
    <>
      <span>{buttonText}</span>
      <svg className="hpop__btn-arrow" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  );

  return (
    <div className="hpop" onClick={onClose} role="dialog" aria-modal="true">
      <div className="hpop__wrap" onClick={(e) => e.stopPropagation()}>
        <button className="hpop__close" onClick={onClose} aria-label="Close">
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
          </svg>
        </button>

        <div className="hpop__card">
          <img src={image} alt="Announcement" className="hpop__img" />

          <div className="hpop__foot">
            {isExternal ? (
              <a className="hpop__btn" href={link} target="_blank" rel="noreferrer" onClick={onClose}>
                {inner}
              </a>
            ) : (
              <Link className="hpop__btn" to={link} onClick={onClose}>
                {inner}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}